"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = void 0;
var react_redux_1 = require("react-redux");
var notification_1 = require("remota-client/hook/notification");
var useNotification = function () {
    var state = (0, react_redux_1.useSelector)(function (state) { return state.notification; });
    return (0, notification_1.useNotificationBase)(state);
};
exports.useNotification = useNotification;
